.search {
  padding: 0.5em;
  margin-left: auto;
  width: max-content;

  background-color: #a6a6a63c;
  backdrop-filter: blur(5px);
}

.searchResults {
  list-style: none;
  padding: 0;
  margin: 1em 0 0;
  width: 18em;
  font-size: small;
}

.searchResult {
  padding: 0.2em;
  display: flex;
  gap: 1em;
  justify-content: space-between;
}

.searchResult:hover {
  background-color: rgb(63, 63, 63);
}

.searchResult[data-selected="true"] {
  background-color: rgb(0, 54, 102);
}

.searchResult_objectName {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
